const LinkedAssetsColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, width: `calc(100% - 310px)` } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "mediaType",
        label: "Media type",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 110 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

/* 모든 에셋 타입(VIDEO/AUDIO/IMAGE/CAPTION/FILE) 공용 컬럼.
   duration은 비디오/오디오만 값이 채워지고 나머지 타입은 빈 칸으로 렌더되어
   확장자·크기 컬럼 위치가 전 타입에서 동일하게 정렬된다. */
const AssetColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 396px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "duration",
        label: "Duration",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

/* 검색/추가 다이얼로그 전용 컴팩트 컬럼 (Figma "Add-Assets-Searched-Asset-row").
   확장자는 name 셀의 subName(.확장자)으로만 표기되어 별도 extensions 컬럼이 없다. */
const SearchedAssetColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 1.5, width: "calc(100% - 110px)" } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
    {
        id: "size",
        label: "Size",
        style: { custom: { width: 110 } },
        disabled: false,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

const PreviewAssetColumn = [
    {
        id: "name",
        label: "Name",
        style: {
            custom: { flex: 1, width: `calc(100% - 120px)`, margin: "8px 8px 12px 12px" },
            thumbnail: { width: 88, height: 88 },
        },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "extensions",
        label: "Extensions",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

export { LinkedAssetsColumn, AssetColumn, SearchedAssetColumn, PreviewAssetColumn };
